import { SettingsGroupProps } from "./types";
import * as Styled from "./styles";

const SettingsGroup: React.FC<React.PropsWithChildren<SettingsGroupProps>> = ({
  label,
  children,
  ...rest
}) => (
  <Styled.SettingsGroup {...rest}>
    <Styled.SettingsGroupLabel>{label}</Styled.SettingsGroupLabel>
    {children}
  </Styled.SettingsGroup>
);

export default SettingsGroup;
